import {  useState } from "react";
import DataTable from "../components/DataTable";
import Page from "../components/Page";
import TableActions from "../components/TableActions";
import { mergeArray } from "../lib/arrayTools";
import { useHistory } from "react-router-dom";
import { useUserProvider } from "../providers/UserProvider";

import {  GetAppResource } from "../services/api/app";
import { useModalProvider } from "../providers/ModalProvider";
import { DeleteContent } from "../services/api/content";

const FlexContentList = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const { showModal, closeModal } = useModalProvider();

  const [data, setData] = useState({
    loading: false,
    data: [],
    count: 0,
  });

  const history = useHistory();

  const { user } = useUserProvider();
  const loadData = async () => {
    setData({ ...data, loading: true });
    GetAppResource(user, "content/flexes")
      .then((res) => res.json())
      .then((jsonData) => {
        setData({
          loading: false,
          data: jsonData.data,
          count: jsonData.data.length,
        });
      });
  };

  const deleteButtonHandler = async (id) => {
    await DeleteContent(id, user.idToken);
    loadData()
    closeModal()
  }


  const links = [
    { name: "Home", url: "/" },
    { name: "FLEX CONTENT LIST", url: "/flex-content" },
  ];

  const metadata = [
    {
      name: "sort_order",
      label: "Sort Order",
      parser: (data) => data.sort_order,
    },
    {
      name: "title",
      label: "Title",
      parser: (data) => data.title,
    },
    {
      name: "active",
      label: "Active",
      parser: (data) => (data.active ? "Yes" : "No"),
    },
    {
      name: "categories",
      label: "Categories",
      parser: (data) => mergeArray(data.categories?.filter?.((category) => category.active === true), "name"),
    },
    {
      name: "tags",
      label: "Tags",
      parser: (data) => data?.tags?.map((tag) => tag.name).join(", "),
    },
    {
      name: "release_date",
      label: "Release Date",
      parser: (data) => data?.release_date,
    },
    {
      name: "actions",
      label: "Actions",
      parser: (data) => (
        <TableActions
          onUpdateClick={updateButtonHandler}
          item_id={data.id}
          onDeleteClick={() => {
            showModal(
              <div>
                <div>Are you sure you to delete this FLEX CONTENT?</div>
                <div className="flex flex-row items-center gap-3 mx-auto justify-center">
                  <button
                    className="ttnk-button mt-2"
                    onClick={() => deleteButtonHandler(data.id)}
                  >
                    Yes
                  </button>
                  <button className="ttnk-button mt-2" onClick={closeModal}>
                    Cancel
                  </button>
                </div>
              </div>
            );
          }}
        />
      ),
    },
  ];

  const AddButton = () => {
    return (
      <button
        className="ttnk-button add-button"
        onClick={() => history.push("/flex-content/new")}
      >
        Add Flex Content
      </button>
    );
  };

  const updateButtonHandler = (id) => {
    history.push(`/flex-content/${id}`);
  };



  return (
    <Page
      links={links}
      title="FLEX CONTENT LIST"
      titleComponent={AddButton()}
    >
      <DataTable
        metadata={metadata}
        dataLoader={loadData}
        data={data}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        searchKeys={["title"]}
      />
    </Page>
  );
};

export default FlexContentList;
